var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBefore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12.631,
    viewBox: "0 0 7 12.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght300_GRAD0_opsz40",
    d: "M355.413-690.172l-5.059-5.066a.671.671,0,0,1-.215-.511.705.705,0,0,1,.227-.515.716.716,0,0,1,.523-.223.716.716,0,0,1,.523.223l5.452,5.452a.951.951,0,0,1,.21.3.869.869,0,0,1,.065.342.877.877,0,0,1-.065.338.937.937,0,0,1-.21.3l-5.464,5.464a.7.7,0,0,1-.511.211.717.717,0,0,1-.523-.223.716.716,0,0,1-.223-.523.716.716,0,0,1,.223-.523Z",
    transform: "translate(357.139 -683.856) rotate(180)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBefore);
export default __webpack_public_path__ + "static/media/before.dd035237f04b13a57a4fa80f71350fdc.svg";
export { ForwardRef as ReactComponent };